/**
 * Emit hosts for the `integration` analytics group — 2 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';
import { type IntegrationRequest } from '@/types';
import { type EHRProvider } from '@heidi/schema/ml-scribe';

// integration
export function integrationRequest(input: IntegrationRequest) {
  trackLegacyEvent({
    name: SegmentObjectName.Integration,
    props: {
      action: SegmentActionName.IntegrationSubmitRequest,
      integrationRequest: input,
    },
  });

  // V2
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.IntegrationSubmitted,
    props: {},
  });
}

export function widgetLinkAccountStartTrialClicked(params: { integrationName?: string }) {
  trackLegacyEvent({
    name: SegmentObjectName.Integration,
    props: {
      ehrProvider: params.integrationName as EHRProvider, // this is just a string anyway
      action: SegmentActionName.WidgetLinkAccountStartTrialClicked,
    },
  });

  // V2
  track({
    event_name: TrackingEventName.ButtonClicked,
    props: {
      label: 'widget_link_account_start_trial_clicked',
      feature: 'integration',
    },
  });
}
